import { Injectable } from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
    providedIn: 'root'
})
export class AuthStateService {
    private publishedLoginKey?: string;
    private previousUrl: string | null = null;
    private currentUrl: string | null = null;
    private tokenRefreshTimeout?: ReturnType<typeof setTimeout>;

    public resetLoginPublication(): void {
        this.publishedLoginKey = undefined;
    }

    public updateNavigation(url: string): string | null {
        this.previousUrl = this.currentUrl;
        this.currentUrl = url;
        return this.previousUrl;
    }

    public shouldPublishLogin(account: AccountInfo, tenant: string): boolean {
        return this.publishedLoginKey !== this.buildLoginPublicationKey(account, tenant);
    }

    public markLoginPublished(account: AccountInfo, tenant: string): void {
        this.publishedLoginKey = this.buildLoginPublicationKey(account, tenant);
    }

    public scheduleTokenRefresh(expiresOn: Date | undefined, refreshBufferMs: number, callback: () => void): void {
        this.clearTokenRefreshTimeout();

        if (!expiresOn) {
            return;
        }

        const refreshDelay = Math.max(expiresOn.getTime() - Date.now() - refreshBufferMs, 0);
        this.tokenRefreshTimeout = setTimeout(() => {
            this.tokenRefreshTimeout = undefined;
            callback();
        }, refreshDelay);
    }

    public clearTokenRefreshTimeout(): void {
        if (!this.tokenRefreshTimeout) {
            return;
        }

        clearTimeout(this.tokenRefreshTimeout);
        this.tokenRefreshTimeout = undefined;
    }

    private buildLoginPublicationKey(account: AccountInfo, tenant: string): string {
        const accountId = account.homeAccountId || account.localAccountId || account.username;
        const normalizedTenant = (tenant || '').trim().toLowerCase();
        return `${accountId}|${normalizedTenant}`;
    }
}